let ip = window.location.hostname;
let APIurl = "";
if (ip === "spmi.kemdikbud.go.id") {
  APIurl = "https://api-spmi.kemdiktisaintek.go.id/";
} else if (ip === "spmi.kemdiktisaintek.go.id") {
  APIurl = "https://api-spmi.kemdiktisaintek.go.id/";
} else if (ip === "dev-spmi.kemdiktisaintek.go.id") {
  APIurl = "https://dev-spmi.kemdiktisaintek.go.id/api/";
} else if (ip === "spmi.dev.kemdiktisaintek.go.id") {
  APIurl = "https://spmi.dev.kemdiktisaintek.go.id/api/";
} else if (ip === "103.56.190.112") {
  APIurl = "http://103.56.190.223:8081/";
} else {
  APIurl = "http://localhost:8081/";
  // APIurl = "https://api-spmi.dikti.go.id/";
  // APIurl = "http://103.56.190.223:8081/";
}
let TracerAPIurl = "http://13.214.19.237/";
let yearsActive1 = [
  '2019',
];
let yearsActive3 = [
  '2021',
  '2022',
  '2023',
];
let yearsActive = yearsActive1.concat(yearsActive3);
let smtDoubleActive = [
  '20211',
  '20212',
  '20221',
  '20222',
  '20231',
  '20232',
];
let datasetpenilaian = [];
for (let i in yearsActive3) {
  let detailsets;
  if (i === 0) {
    detailsets = {
      label: yearsActive3[i],
      backgroundColor: 'rgb(35,110,150)',
      borderColor: 'rgb(69,69,69)',
      borderWidth: 0.5,
      data: ['3', '3', '2', '2', '4']
    }
  } else if (i === 1) {
    detailsets = {
      label: yearsActive3[i],
      backgroundColor: 'rgb(21,178,211)',
      borderColor: 'rgb(69,69,69)',
      borderWidth: 0.5,
      data: ['1', '2', '2', '5', '3']
    }
  } else if (i === 2) {
    detailsets = {
      label: yearsActive3[i],
      backgroundColor: 'rgb(255,215,0)',
      borderColor: 'rgb(69,69,69)',
      borderWidth: 0.5,
      data: ['4', '2', '3', '5', '2']
    }
  }
  datasetpenilaian.push(detailsets);
}

const AppConfig = {
  urlDefault: APIurl,
  yearsActive: yearsActive,
  yearsActive3: yearsActive3,
  smtDoubleActive: smtDoubleActive,
  datasetpenilaian: datasetpenilaian,
  Authentication: APIurl + "auth/login",
  SetRole: APIurl + "auth/setrole",
  GetRole: APIurl + "auth/getrole",
  // PROFIL
  Profile: APIurl + "infopt",
  // DASHBOARD
  urlAPiGetDashboard: APIurl + "penetapan/dashboard",
  urlApiGetListPT: APIurl + "penetapan/listpt",
  DetailDashboard: APIurl + "dashboard/",
  MhsTerdaftar: APIurl + "dashboard/mhsterdaftar",
  DosenIkatan: APIurl + "dashboard/dosenikatan",
  JabFung: APIurl + "dashboard/jabfung",
  MhsJenisPendaftaran: APIurl + "dashboard/mahasiswabaru",
  ProdiByPT: APIurl + "dashboard/prodibypt",
  // PENETAPAN
  urlGetPengaturan: APIurl + "penetapan/getpengaturan/",
  urlDetailAjuan: APIurl + "pengaturan/ajuandetail",
  urlGetHistoricalPengaturan: APIurl + "pengaturan/history/",
  urlGetHistoricalPengaturanSiklus: APIurl + "pengaturan/historysiklus/",
  urlAPiPostDataPT: APIurl + "penetapan/savepengaturan",
  urlDeletePengaturan: APIurl + "pengaturan/hapuspengaturan/",
  urlGetPengaturanJenisAturan: APIurl + "pengaturan/jenisaturan/",
  urlGetPengaturanJenisAturanSiklus: APIurl + "pengaturan/jenisaturansiklus/",
  urlAPiPutDataPT: APIurl + "penetapan/editpengaturan",
  //Pelaksanaan
  urlAPiGetDataPT: APIurl + "penetapan/getdatapt/",
  urlAPiGetLulusan: APIurl + "penetapan/getlulusan/",
  urlIpsPenilaian: APIurl + "penetapan/ipspenilaian/",
  urlAPiGetDataStatuta: APIurl + "penetapan/statuta/",
  urlProsesPembelajaran: APIurl + "penetapan/prosespembelajaran/",
  //EVALUASI
  urlGetEvaluasi: APIurl + "evaluasi/getevaluasi/",
  urlGetEvaluasiSiklus: APIurl + "evaluasi/getevaluasisiklus/",
  urlDetailEvaluasi: APIurl + "evaluasi/detail",
  urlPostEvaluasi: APIurl + "evaluasi/saveevaluasi",
  urlGetEvaluasiLain: APIurl + "evaluasi/history/",
  urlGetEvaluasiLainSiklus: APIurl + "evaluasi/historysiklus/",
  SaveTarget: APIurl + "penetapan/savetarget",
  urlGetTarget: APIurl + "penetapan/gettarget/",
  urlDeleteEvaluasi: APIurl + "evaluasi/hapusevaluasi/",
  //PENINGKATAN
  SavePeningkatan: APIurl + "peningkatan/savepeningkatan",
  // by id_sp
  GetPeningkatan: APIurl + "peningkatan/getpeningkatan/",
  GetPeningkatanSiklus: APIurl + "peningkatan/getpeningkatansiklus/",
  // by id_sp
  GetPeningkatanFinal: APIurl + "/peningkatan/getpeningkatanfinal/",
  // by ID
  GetDetailPeningkatan: APIurl + "peningkatan/ajuandetail/",
  //by id_sp dan jenis pengaturan
  GetHistorical: APIurl + "peningkatan/history/",
  GetPeningkatanSiklusHistory: APIurl + "peningkatan/historysiklus/",
  // by id_ajuan_peningkatan
  DeletePeningkatan: APIurl + "peningkatan/hapuspengaturan/",
  //PENGENDALIAN http://localhost:8081/pengendalian/list/:id_sp
  FormRefPengendalian: APIurl + "pengendalian/pengaturanpt",
  SavePengendalian: APIurl + "pengendalian/savepengendalian",
  // by id pt pengendalian/detail/
  ListPengendalian: APIurl + "pengendalian/list/",
  ListPengendalianBySiklus: APIurl + "pengendalian/listsiklus/",
  DetailsPengendalian: APIurl + "pengendalian/detail/",
  DetailAjuanPengendalian: APIurl + "pengendalian/ajuandetail",
  HistoryPengendallian: APIurl + "pengendalian/history/",
  HistoryPengendalianSiklus: APIurl + "pengendalian/historysiklus/",
  DeletePengendalian: APIurl + "pengendalian/hapuspengaturan/",
  // MANAJEMEN ROLE
  SaveManajemenRole: APIurl + "manajemenrole/save",
  UpdateManajemenRole: APIurl + "manajemenrole/update",
  ListManajemenRole: APIurl + "manajemenrole/index",
  DetailsManajemenRole: APIurl + "manajemenrole/detail/",
  DeleteManajemenRole: APIurl + "manajemenrole/delete/",
  // MANAJEMEN USER
  // SaveManajemenRole : APIurl + "manajemenrole/save",
  ListManajemenUser: APIurl + "manajemenuser/index",
  UpdateManajemenUser: APIurl + "manajemenuser/update",
  DeleteManajemenUser: APIurl + "manajemenuser/delete/",
  DetailsManajemenUser: APIurl + "manajemenuser/detail/",
  SaveManajemenUser: APIurl + "manajemenuser/save",
  ResetPassword: APIurl + "manajemenuser/reset-pass/",
  ListRole: APIurl + "manajemenuser/list-role/",
  AddRole: APIurl + "manajemenuser/role/",
  ListUnit:
    "https://api-pddikti-admin.kemdikbud.go.id/user/role/21/lNLIg0rKq_ZEMofFFRwVnkXPKU2mYTZtqK-yeZVz5U-SR5gt3JKm595RE69Y0lgDnkdOnw==?token=7lLKfk_B_DtamLvCwc4LNnOlou8BPD-bR3X57Erjg3z45yB7Xv6KfudiZXf1a0aIZ6Eq6Zpz88g3g_Yipnshc8qEW9JXhb-4zSg=&id_pengguna=avDSAUoDyVf49u2aPb6vPVyIj8twuXhnmjk2MrZJZ7Bj5vumjvHhnS2IgyoVBabEWkGNKQ==&id_unit=3CjBNmNs3WjsBZyeCVzBCCWOtG2clbJ9GfQbDmqG3_RxnlG6d-RFtLfE6Cts-ZNvQethwQ==&id_role=1&sso=true",
  SaveRole: APIurl + "manajemenuser/role/add",
  DeleteRole: APIurl + "manajemenuser/role/delete/",
  GetStatusDashboard: APIurl + "dashboard/status/",
  // Penugasan Faswil
  ListPenugasanFaswil: APIurl + "penugasanfaswil/list",
  DetailPenugasanFaswil: APIurl + "penugasanfaswil/detail/",
  EditPenugasanFaswil: APIurl + "penugasanfaswil/edit/",
  DeletePenugasanFaswil: APIurl + "penugasanfaswil/deletept/",
  DeleteAllPenugasanFaswil: APIurl + "penugasanfaswil/deleteall/",
  GetPTPenugasanFaswil: APIurl + "penugasanfaswil/getpt",
  SavePTPenugasanFaswil: APIurl + "penugasanfaswil/savept",
  AddPenugasanFaswil: APIurl + "penugasanfaswil/add",
  GetPenggunaPenugasanFaswil: APIurl + "penugasanfaswil/getpengguna",
  SavePenugasanFaswil: APIurl + "penugasanfaswil/save",
  ListPenggunaPenugasanFaswil: APIurl + "penugasanfaswil/listpengguna",
  ListPenetapanStandarPenugasanFaswil:
    APIurl + "penugasanfaswil/penetapan-standar/",
  ListEvaluasiPelaksanaanPenugasanFaswil:
    APIurl + "penugasanfaswil/evaluasi-pelaksanaan/",
  ListPengendalianPenugasanFaswil: APIurl + "penugasanfaswil/pengendalian/",
  ListPeningkatanPenugasanFaswil: APIurl + "penugasanfaswil/peningkatan/",
  // DATA LOG
  DataLog: APIurl + "data-log/list",
  // Data Tracer Study
  TracerGetToken: TracerAPIurl + "auth/req-token",
  TracerStatictikKeselarasanBar: TracerAPIurl + "statistik/bar/keselarasan",
  TracerStatictikKeselarasanPie: TracerAPIurl + "statistik/pie/keselarasan",
  TracerStatictikTinggiSamaRendahBar: TracerAPIurl + "statistik/bar/ketinggian",
  TracerStatictikTinggiSamaRendahPie: TracerAPIurl + "statistik/pie/ketinggian",
  TracerStatictikPekerjaanBar: TracerAPIurl + "statistik/bar/pekerjaan",
  TracerStatictikPekerjaanPie: TracerAPIurl + "statistik/pie/pekerjaan",
  // Rekapitulasi
  ListRekapitulasi: APIurl + "dashboard/rekapspmi",
  ListDetailRekapitulasi: APIurl + "dashboard/rekapspmi/",
  ListDetailSPMI: APIurl + "dashboard/rekapdetailspmi/",
  GetNotification: APIurl + "dashboard/notif/",
  ReadNotif: APIurl + "dashboard/notif-read",
  ReadNotifReviewer: APIurl + "dashboard/notif-read-reviewer",
  GetNotifSelainPT: APIurl + "dashboard/notifikasi",
  // Informasi
  ListInformasi: APIurl + "cms/index",
  EditInformasi: APIurl + "cms/edit/",
  SaveInformasi: APIurl + "cms/save",
  DeleteInformasi: APIurl + "cms/delete/",
  ListKonten: APIurl + "cms/informasi",
  CommentSave: APIurl + "comment/save",
  CommentDelete: APIurl + "comment/delete/",
  // Pengelola PT
  ListPengelolaPT: APIurl + "pengelola-pt/index",
  SavePengelolaPT: APIurl + "pengelola-pt/save",
  UpdatePengelolaPT: APIurl + "pengelola-pt/update",
  DeletePengelolaPT: APIurl + "pengelola-pt/delete",
  DataSurveiKepuasan: APIurl + "dashboard/survei-kepuasan",
  SaveDataSurveiKepuasan: APIurl + "dashboard/save-survei-kepuasan",
  DeleteDataSurveiKepuasan: APIurl + "dashboard/delete-survei-kepuasan",

  SearchPT: APIurl + "ajax/pt",

  DampakTridharmaList: APIurl + "dampaktridharma/list/",
  DampakTridharmaListSiklus: APIurl + "dampaktridharma/listsiklus/",
  DetailsDampakTridharma: APIurl + "dampaktridharma/detail/",
  DampakTridharmaSave: APIurl + "dampaktridharma/save",
  DampakTridharmaDelete: APIurl + "dampaktridharma/delete/",
  DampakTridharmaHistory: APIurl + "dampaktridharma/history/",
  DampakTridharmaHistorySiklus: APIurl + "dampaktridharma/historysiklus/",
  DampakTridharmaDetail: APIurl + "dampaktridharma/detail/",
};
export default AppConfig;
